import { render, staticRenderFns } from "./OrganizerEdit.vue?vue&type=template&id=23c958fb"
import script from "./OrganizerEdit.vue?vue&type=script&lang=js"
export * from "./OrganizerEdit.vue?vue&type=script&lang=js"
import style0 from "./OrganizerEdit.vue?vue&type=style&index=0&id=23c958fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports